export default "__VITE_ASSET__26b293a4__"